import Component from '../core/Component'

export default class FixBrokenTable extends Component {
    constructor(element) {
        super(element)
    }

    prepare() {
        const table = document.querySelector('table')
        const wrapperDiv = document.createElement('div');
        wrapperDiv.classList.add('TableWrapper')
        table.parentNode.insertBefore(wrapperDiv, table);
        wrapperDiv.appendChild(table);
    }
}
